import type { ComponentPropsWithRef, ReactNode } from "react";

type BrowseLinkProps = ComponentPropsWithRef<"a"> & { readonly href: string };

export type BrowseLinkRenderer = (props: BrowseLinkProps) => ReactNode;

export const renderNativeLink: BrowseLinkRenderer = ({
  children,
  ...props
}) => <a {...props}>{children}</a>;
